<template>
  <AModal name="team-member">
    <div
      class="our-team-member"
      @click.self="closeModal"
    >
      <div class="our-team-modal">
        <img
          :src="activeMember.img.src"
          alt="our-team"
          class="our-team-modal__image"
        >
        <div class="our-team-content">
          <h3 class="our-team-content__name">{{ activeMember.name }}</h3>
          <p class="our-team-content__position">{{ activeMember.worckPosition }}</p>
          <div v-html="activeMember.description" class="our-team-content__text" />
        </div>
        <div
          @click="closeModal"
          class="our-team-modal-close"
        >
          <svg class="our-team-modal-close__icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="14.1426" width="20" height="2" transform="rotate(-45 0 14.1426)" fill="#68737D"/>
            <rect x="14.1484" y="15.5566" width="20" height="2" transform="rotate(-135 14.1484 15.5566)" fill="#68737D"/>
          </svg>
        </div>
      </div>
    </div>
  </AModal>
</template>

<script>
import {AModal, useAModal} from "../ui";
import { useTeam } from "../../composables/useTeam";

export default {
  name: 'OurTeamMember',
  props: ['result'],
  components: {
    AModal,
  },
  setup() {
    const modal = useAModal();

    const { activeMember } = useTeam();

    const closeModal = () => {
      modal.hide('team-member');
    }

    return {
      closeModal,
      activeMember,
    }
  }
}
</script>

<style lang="scss" scoped>
.our-team-member {
  min-height: 100vh;
  background-color: #6367A7;
}
.our-team-modal{
  display: grid;
  grid-template-columns: 445px 1fr;
  grid-column-gap: 62px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 1160px;
  background: #FFFFFF;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  max-height: 100vh;
  overflow-y: auto;
  width: 100%;
  @include tablet{
    grid-template-columns: 300px 1fr;
    grid-column-gap: 30px;
  }
  @include mobile{
    grid-template-columns: 1fr;
  }
  &__image{
    display: block;
    width: 100%;
  }
}
.our-team-content{
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 58px 58px 58px 0;
  @include tablet{
    padding: 30px 30px 30px 0;
  }
  @include mobile{
    padding: 30px;
  }
  &__name{
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    margin: 0 0 4px;
    @include tablet{
      font-size: 18px;
    }
  }
  &__position{
    font-size: 16px;
    line-height: 22px;
    color: #00A59E;
    margin-bottom: 22px;
    @include tablet{
      font-size: 14px;
      margin-bottom: 18px;
    }
  }
  &__text{
    :deep{
      p{
        font-family: 'Montserrat';
        font-size: 22px;
        line-height: 28px;
        color: #000000;
        margin-bottom: 38px;
        @include tablet{
          font-size: 18px;
          margin-bottom: 24px;
        }
      }
      p:nth-child(2){
        font-weight: 600;
        @include tablet{
          font-size: 18px;
        }
      }
      p:last-child{
        margin-bottom: 0;
      }
    }
  }
}
.our-team-modal-close{
  position: absolute;
  top: 22px;
  right: 16px;
  cursor: pointer;
}
</style>